import React from "react";
import "../deliveryNote/deliveryNote.scss";

const DeliveryNoteDetails = () => {
  return (
    <section id="deliveryNoteDetails">
      <div className="container-fluid">
        <div className="row pt-1">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-1">
              <div className="card-body">
                <div className="row share-area-row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>
                        <i class="fas fa-angle-left mr-2"></i>DELR-DR-R664
                      </h6>
                      <button className="btn export-btn" type="button">
                        <i class="fas fa-share-square"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-1">
              <div className="card-body">
                <div className="row product-details-row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto"></div>
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Delivery Date</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Division</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Customer Name</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Project</label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Payment Terms</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Order Ref</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Customer LPO</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Distributor</label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Sales Engineer</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Taken By</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Phone Number(Taken By)</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Delivery Address</label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Delivered Person</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Phone Number(Delivered Person)</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Country</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Delivery Method</label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Licensed Model</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Additional Note</label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card mb-1">
              <div className="card-body">
                <div className="row product-details-heading-row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
                    <div>
                      <h6>Product Details</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-1">
              <div className="card-body">
                <div className="row product-details-table-row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto"></div>
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>Batch Ref</th>
                        <th>Tag Ref</th>
                        <th>Product Group</th>
                        <th>Product Model</th>
                        <th>Size Parameters</th>
                        <th className="text-right">Quantity</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01-LAD/4956-59</td>
                        <td>SLSD-14-W2W3 Fifth Floor</td>
                        <td>1.5 hour Rated Static Fire Damper</td>
                        <td>KRLAD F-100</td>
                        <td>2400x3xOne Side</td>
                        <td className="text-right">200</td>
                        <td>
                          <span class="popover__wrapper">
                            <span class="material-symbols-rounded">info</span>
                            <div class="popover__content">
                              <div className="card">
                                <div className="card-header">
                                  <h6>1.5 hour Rated Static Fire Damper</h6>
                                  <p>GModel - 119</p>
                                </div>
                                <div className="card-body">
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Slot Width</label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Type</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>
                                            Material of Construction
                                          </label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>RAL Color</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Opposed Blade Damper</label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Bank Off Plate</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>
                                            Blank Off Plate Material
                                          </label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Bank Off Plate Length</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Plenum</label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Plenum Width</label>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>01-LAD/4956-59</td>
                        <td>SLSD-14-W2W3 Fifth Floor</td>
                        <td>1.5 hour Rated Static Fire Damper</td>
                        <td>KRLAD F-100</td>
                        <td>2400x3xOne Side</td>
                        <td className="text-right">200</td>
                        <td>
                          <span class="popover__wrapper">
                            <span class="material-symbols-rounded">info</span>
                            <div class="popover__content">
                              <div className="card">
                                <div className="card-header">
                                  <h6>1.5 hour Rated Static Fire Damper</h6>
                                  <p>GModel - 119</p>
                                </div>
                                <div className="card-body">
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Slot Width</label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Type</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>
                                            Material of Construction
                                          </label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>RAL Color</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Opposed Blade Damper</label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Bank Off Plate</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>
                                            Blank Off Plate Material
                                          </label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Bank Off Plate Length</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Plenum</label>
                                        </td>
                                        <td>
                                          <h5>ORD-789-JK95</h5>
                                          <label>Plenum Width</label>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeliveryNoteDetails;
